
export default {
  name: 'BaseProfileAuthorDescription',
  props: {
    descriptions: {
      type: Object,
      default: null,
    },
    authorId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      maxCharactersToHidden: 800,
      isShowContent: false,
    }
  },

  computed: {
    isAuthor() {
      if (this.$auth.loggedIn && this.authorId) {
        return this.$auth?.user?._id === this.authorId
      } else {
        return false
      }
    },
    isCompany() {
      return this.$auth.loggedIn && this.$auth.user?.type === 'COMPANY'
    },
    numberOfCharacters() {
      const paragraphs = this.descriptions?.blocks?.filter(
        (block) => block.type === 'paragraph'
      )
      const paragraphsTextLength =
        paragraphs && paragraphs.length
          ? paragraphs.reduce((acc, block) => {
              return acc + block.data.text.length
            }, 0)
          : 0
      const lists = this.descriptions?.blocks?.filter(
        (block) => block.type === 'list'
      )
      const listsTextLength = this.listTextLength(lists)

      const headers = this.descriptions?.blocks?.filter(
        (block) => block.type === 'header'
      )
      const headersTextLength =
        headers && headers.length
          ? headers.reduce((acc, block) => {
              return acc + block.data.text.length
            }, 0)
          : 0
      const quotes = this.descriptions?.blocks?.filter(
        (block) => block.type === 'quote'
      )
      const quotesTextLength =
        quotes && quotes.length
          ? quotes.reduce((acc, block) => {
              return acc + block.data.text.length + block.data.caption.length
            }, 0)
          : 0

      const tables = this.descriptions?.blocks?.filter(
        (block) => block.type === 'table'
      )
      const tablesTextLength =
        tables && tables.length
          ? tables.reduce((acc, block) => {
              return (
                acc +
                block.data.content.reduce((acc, el) => {
                  return (
                    acc +
                    el.reduce((acc, el) => {
                      return acc + el.length
                    }, 0)
                  )
                }, 0)
              )
            }, 0)
          : 0

      const countTextCharacters =
        paragraphsTextLength +
        listsTextLength +
        headersTextLength +
        quotesTextLength +
        tablesTextLength
      return countTextCharacters
    },
    isHidden() {
      return this.numberOfCharacters > this.maxCharactersToHidden
    },
  },
  methods: {
    listTextLength(lists) {
      const listsTextLength =
        lists && lists.length
          ? lists.reduce((acc, block) => {
              return acc + this.countListItemsText(block.data.items)
            }, 0)
          : 0
      return listsTextLength
    },
    countListItemsText(items) {
      if (items && items.length) {
        return items.reduce((acc, item) => {
          let count = acc + item.content.length
          if (item.items && item.items.length) {
            count = count + this.countListItemsText(item.items)
          }
          return count
        }, 0)
      }
    },
  },
}
